import { CustomButton } from '@shared/ui'
import { routes } from '@shared/constants/constants'
import styles from './RegisterBtn.module.scss'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const RegisterBtn = ({ className, onClick, variant = 'white' }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      navigate(`${routes.registration}/?_stage=stepOne`)
    }
  }

  return (
    <CustomButton
      onClick={handleClick}
      variant={variant}
      className={classNames(styles.btn, className)}
    >
      {t('buttons.singUp')}
    </CustomButton>
  )
}
